
import { ArrowLeft, Trash2, X } from "react-feather";
import styles from "../prospectdetails.module.css";
import { Button, DialogContent, DialogTitle, FormControl, InputLabel, TextField, MenuItem, Select, OutlinedInput, Box, Chip, Checkbox, ListItemText } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { ListManager } from "react-beautiful-dnd-grid";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useHistory } from "react-router-dom";

function sortList(list) {
    let listTemp = list.slice().sort((first, second) => first.order - second.order);
    listTemp = listTemp.map((i, index) => {
        return { ...i, index: index };
    });
    return listTemp;
}

function ListElement({ item: { id, title, index } }) {
    return (<Chip className={"DropListNew"} key={id} label={index + 1 + ". " + title} />);
}

function MoneyField(props) {
    return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={true} allowNegative={false} decimalScale={2} fixedDecimalScale {...props} />);
}

const LeaseForm = (props) => {
    const redirect = useHistory();
    const { getAccessTokenSilently } = useAuth0();
    const [LeaseDocumentOptions, setLeaseDocumentOptions] = useState([]);
    const [selectDocument, setSelectDocument] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectDocumentIds, setSelectDocumentIds] = useState([]);
    const [sortedLeaseDocuments, setSortedLeaseDocuments] = useState(sortList([]));
    const [propertyDet, setPropertyDet] = useState(null);
    const [apartments, setApartments] = useState([]);
    const [selectedApartment, setSelectedApartment] = useState(null);
    const [leaseStartDate, setLeaseStartDate] = useState(null);
    const [moveInDate, setMoveInDate] = useState(null);
    const [currentRent, setCurrentRent] = useState(0);
    const [openUploadArea, setOpenUploadArea] = useState(false);
    const [openSelectArea, setOpenSelectArea] = useState(false);
    const [uploadFiles, setUploadFiles] = useState([]);

    const schema = yup.object().shape({
        property_id: yup.string().required("This field is Required"),
        apt_id: yup.string().required("This field is Required"),
        lease_term: yup.string().required("This field is Required"),
        security_amount: yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0).test("max-4-digit", "Security Amount can not be more than 6 digits.", (value) => {
            if (typeof (value) !== 'undefined')
                return parseInt(value.replace(/,/g, "")) < 10000;
        }),
        rent: yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0
        ).test("max-4-digit", "Rent can not be more than 6 digits.", (value) => {
            if (typeof (value) !== 'undefined')
                return parseInt(value.replace(/,/g, "")) < 10000;
        }),
        first_rent: yup.string().required("This field is Required").test("non-zero-validate", "This field should be $1 or greater.", (value) => parseInt(value) > 0
        ).test("max-4-digit", "Rent can not be more than 6 digits.", (value) => {
            if (typeof (value) !== 'undefined')
                return parseInt(value.replace(/,/g, "")) < 10000;
        }),
        pet_fee: yup.string().test("max-4-digit", "Pet fee can not be more than 6 digits.", (value) => {
            if (typeof (value) !== 'undefined' && value !== "")
                return parseInt(value.replace(/,/g, "")) < 10000;
            else
                return true;
        }),
        start_date: yup.date().required("This field is Required"),
        end_date: yup.date().required("This field is Required"),
        move_in_date: yup.date().required("This field is Required"),
        is_existing: yup.string().required("This field is Required"),
        docume_ids: yup.array().when("is_existing", (is_existing) => {
            if (is_existing && is_existing === "No")
                return yup.array().required("This field is Required").nullable();
            else return yup.array();
        }),
        document_files: yup.array().when("is_existing", (is_existing) => {
            if (is_existing && is_existing === "Yes")
                return yup.mixed().test("required", "Please upload documents.", (file) => {
                    if (uploadFiles.length !== 0) return true;
                    return false;
                });
            else return yup.array();
        }),
    });

    const { register, handleSubmit, control, errors, setValue, getValues, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            lease_term: "1 Year",
            property_id: '',
            apt_id: ''
        }
    });

    useEffect(() => {
        if (props.leaseFormData) {
            if (props?.leaseFormData?.applicant_det?.rent) {
                setValue('property_id', props?.leaseFormData?.property_det?.id);
                setValue('apt_id', props?.leaseFormData?.applicant_det?.id);

                let apartemntTemp = apartments?.filter(i => i?.value === props?.leaseFormData?.applicant_det?.id);
                if (apartemntTemp.length > 0) {
                    setSelectedApartment(apartemntTemp[0]);
                }

                setPropertyDet(props?.leaseFormData?.property_det);
            }

            if (props?.leaseFormData?.lease_documents) {
                setLeaseDocumentOptions(props?.leaseFormData?.lease_documents);
            }
        }
    }, [props.leaseFormData, setValue, apartments]);

    useEffect(() => {
        async function fetchData() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/apartments/" + propertyDet?.id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setApartments(response?.data?.data);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }
        if (propertyDet?.id) {
            fetchData();
        }
    }, [propertyDet?.id, getAccessTokenSilently]);

    useEffect(() => {
        let ids = selectDocument.map((i) => {
            return i.id;
        });

        let docs = selectDocument.map((i, index) => {
            return { ...i, order: index, index: index };
        });

        setSelectDocumentIds(ids);

        setSortedLeaseDocuments(docs);
    }, [selectDocument]);

    const onSubmit = async (data) => {
        let docume_ids = "";
        if (data.is_existing === "No") {
            let dIds = sortedLeaseDocuments?.map((i) => {
                return i.id;
            });
            docume_ids = dIds.join();
        }

        const formData = new FormData();

        Object.keys(data).map((key) => {
            if (key === "lease_term") {
                formData.append("lease_term", data?.lease_term);
            } else if (key === "rent") {
                formData.append("rent", data.rent.replace(/,/g, ""));
            } else if (key === "first_rent") {
                formData.append("first_rent", data.first_rent.replace(/,/g, ""));
            } else if (key === "security_amount") {
                formData.append("security_amount", data.security_amount.replace(/,/g, ""));
            } else if (key === "pet_fee") {
                if (data?.pet_fee !== "") {
                    let petAmnt = data?.pet_fee?.replace(/,/g, "");
                    petAmnt = parseFloat(petAmnt);
                    if (petAmnt > 0)
                        formData.append("pet_fee", petAmnt);
                }
            } else if (key === "start_date") {
                formData.append("start_date", dayjs(data.start_date).format("YYYY-MM-DD"));
            } else if (key === "end_date") {
                formData.append("end_date", dayjs(data.end_date).format("YYYY-MM-DD"));
            } else if (key === "move_in_date") {
                formData.append("move_in_date", dayjs(data.move_in_date).format("YYYY-MM-DD"));
            } else if (key === "property_id") {
                formData.append("property_id", data?.property_id);
            } else if (key === "apt_id") {
                formData.append("apt_id", data?.apt_id);
            }
            return false;
        });

        formData.append("is_esign", data.is_existing === "Yes" ? 0 : 1);

        if (data?.is_existing === "Yes") {
            formData.append("uploadFile", uploadFiles[0]);
        } else {
            formData.append("docume_ids", docume_ids);
        }

        props?.setLoading(true);
        props?.setAddLeaseModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.post(process.env.REACT_APP_APPLICANT_API_URL + "v1/prospects/" + props.applicant_id + "/move-in-tenant", formData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            props?.setLoading(false);

            props.setSnackbarMsg(response.data.message);
            props.setSnackbarOpen(true);

            setTimeout(() => {
                redirect.push("/people/tenants/details/" + response?.data?.data?.id);
            }, 2000);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            props?.setLoading(false);
        });
    }

    const selectDocuments = (event) => {
        const { target: { value } } = event;
        setSelectDocument(value);
        setValue("docume_ids", value);
    };

    const reorderList = (sourceIndex, destinationIndex) => {
        if (destinationIndex === sourceIndex) {
            return;
        }
        const list = sortedLeaseDocuments;

        if (destinationIndex === 0) {
            list[sourceIndex].order = list[0].order - 1;

            setSortedLeaseDocuments(sortList(list));
            return;
        }

        if (destinationIndex === list.length - 1) {
            list[sourceIndex].order = list[list.length - 1].order + 1;
            setSortedLeaseDocuments(sortList(list));
            return;
        }

        if (destinationIndex < sourceIndex) {
            list[sourceIndex].order = (list[destinationIndex].order + list[destinationIndex - 1].order) / 2;
            setSortedLeaseDocuments(sortList(list));
            return;
        }

        list[sourceIndex].order = (list[destinationIndex].order + list[destinationIndex + 1].order) / 2;
        setSortedLeaseDocuments(sortList(list));
    }

    useEffect(() => {
        let rentAmnt = selectedApartment?.rent;

        setValue('security_amount', rentAmnt);
        setValue('rent', rentAmnt);

        setCurrentRent(rentAmnt);

    }, [selectedApartment, setValue]);

    useEffect(() => {
        let rentAmnt = currentRent;

        if (typeof (rentAmnt) === 'string') {
            rentAmnt = rentAmnt.replace(/,/g, "");
            rentAmnt = parseFloat(rentAmnt);
        }

        if (leaseStartDate !== null && moveInDate !== null) {
            let startDateF = dayjs(leaseStartDate).format('YYYY-MM-DD');
            let moveInDateF = dayjs(moveInDate).format('YYYY-MM-DD');

            if (startDateF !== moveInDateF) {
                let monthlyRent = rentAmnt;
                let totaldateOfMonth = dayjs(moveInDate).daysInMonth();
                let remainingDateOfMonth = dayjs(moveInDate).endOf('month').diff(dayjs(moveInDate), 'day');
                remainingDateOfMonth = remainingDateOfMonth + 1;
                let newRent = ((monthlyRent / totaldateOfMonth) * remainingDateOfMonth);
                newRent = Math.round(newRent);
                setValue('first_rent', newRent);
            } else {
                setValue('first_rent', rentAmnt);
            }
        } else {
            setValue('first_rent', rentAmnt);
        }

    }, [leaseStartDate, moveInDate, setValue, currentRent]);

    const fileHandler = (e) => {
        var validExtensions = ["pdf"]; //array of valid extensions
        var fileName = e.target.files[0].name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
        if (validExtensions.indexOf(fileNameExt.toLowerCase()) === -1) {
            toast.error("File type is not allowed.");
        } else if (e.target.files[0].size > 10485760) {
            toast.error("Image size should not be greater than 10 mb.");
        } else if (uploadFiles.length >= 5) {
            toast.error("You cann't upload more than 5 files.");
        } else {
            setUploadFiles((prevFiles) => {
                return [e.target.files[0]];
            });
        }
    }

    const removeFile = (index) => {
        setUploadFiles([]);
    }

    return (<>
        <DialogTitle id="alert-dialog-title">
            <button className={`${styles.BackAddBU}`} onClick={(e) => props.setAddLeaseModalOpen(false)}>
                <ArrowLeft />
            </button>
            <span>Add Lease</span>
            <button onClick={(e) => props.setAddLeaseModalOpen(false)}><X /></button>
        </DialogTitle>

        <DialogContent className={`${styles.ProfileCardEditSec}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className={`${styles.AddTenantpopupBody}`}>
                        <div className={`${styles.AddTenantpopupBodyRow}`}>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                                    <Controller
                                        name="property_id"
                                        control={control}
                                        render={(field) => (<Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label={"Property*"}
                                            disabled
                                        >
                                            <MenuItem value={propertyDet?.id}>{propertyDet?.name}</MenuItem>
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors.property_id.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Apartment*</InputLabel>
                                    <Controller
                                        name="apt_id"
                                        control={control}
                                        render={(field) => (<Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Apartment*"
                                            onChange={(e) => {
                                                field.onChange(e);

                                                let apartemntTemp = apartments?.filter(i => i?.value === e.target.value);
                                                if (apartemntTemp.length > 0) {
                                                    setSelectedApartment(apartemntTemp[0]);
                                                }
                                            }}
                                            renderValue={(value) => {
                                                let apartmentTemp = apartments?.filter(i => i?.value === value);
                                                if (apartmentTemp) {
                                                    if (apartmentTemp.length) {
                                                        return apartmentTemp[0].label;
                                                    }
                                                }

                                                return null;
                                            }}
                                        >
                                            {apartments?.map((item) => {
                                                return (<MenuItem key={item?.value} value={item?.value} disabled={item?.current_status !== 1} className="EditAptDropdown">
                                                    <p>{item?.label} (${item?.formatted_rent})</p>
                                                    {item?.current_status === 2 && <p className={`${styles.ArtStatusTag} ${styles.Rented}`}>Rented</p>}
                                                    {item?.current_status === 3 && <p className={`${styles.ArtStatusTag} ${styles.Coming}`}>Coming Soon</p>}
                                                    {item?.current_status === 4 && <p className={`${styles.ArtStatusTag} ${styles.NotAva}`}>Not Available</p>}
                                                </MenuItem>);
                                            })}
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors.apt_id && (<p className={`${styles.ErrorM}`}>{errors.apt_id.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Lease term*</InputLabel>
                                    <Controller
                                        name="lease_term"
                                        control={control}
                                        render={(field) => (<Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Lease term*"
                                            onChange={(e) => {
                                                field.onChange(e);
                                            }}
                                        >
                                            <MenuItem value="6 Months">6 Months</MenuItem>
                                            <MenuItem value="9 Months">9 Months</MenuItem>
                                            <MenuItem value="1 Year">1 Year</MenuItem>
                                            <MenuItem value="2 Years">2 Years</MenuItem>
                                            <MenuItem value="3 Years">3 Years</MenuItem>
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors.lease_term && (<p className={`${styles.ErrorM}`}>{errors.lease_term.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="security_amount"
                                    control={control}
                                    render={(field) => (<MoneyField {...field} id="outlined-basic" variant="outlined" label="Security Amount*" value={field.value ? field.value : ""} />)}
                                />
                                {errors.security_amount && (<p className={`${styles.ErrorM}`}>{errors.security_amount.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="rent"
                                    control={control}
                                    render={(field) => (<MoneyField
                                        {...field}
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="Monthly Rent*"
                                        value={field.value ? field.value : ""}
                                        onChange={(e) => {
                                            field.onChange(e);

                                            setCurrentRent(e.target.value);
                                        }}
                                    />)}
                                />
                                {errors.rent && (<p className={`${styles.ErrorM}`}>{errors.rent.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="pet_fee"
                                    control={control}
                                    render={(field) => (<MoneyField
                                        {...field}
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="Pet Fee"
                                        value={field.value ? field.value : ""}
                                        onChange={(e) => {
                                            field.onChange(e);
                                        }}
                                    />)}
                                />
                                {errors.pet_fee && (<p className={`${styles.ErrorM}`}>{errors.pet_fee.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="start_date"
                                    control={control}
                                    render={(field) => (<DatePicker
                                        {...field}
                                        label="Lease start date*"
                                        renderInput={(params) => (<TextField {...params} />)}
                                        onChange={(e) => {
                                            field.onChange(e);

                                            setValue("move_in_date", dayjs(e));
                                            setLeaseStartDate(dayjs(e));
                                            setMoveInDate(dayjs(e));

                                            clearErrors();
                                            if (getValues("lease_term") === "6 Months") {
                                                setValue("end_date", dayjs(e).add(6, "months").subtract(1, "day"));
                                            } else if (getValues("lease_term") === "9 Months") {
                                                setValue("end_date", dayjs(e).add(9, "months").subtract(1, "day"));
                                            } else if (getValues("lease_term") === "1 Year") {
                                                setValue("end_date", dayjs(e).add(1, "year").subtract(1, "day"));
                                            } else if (getValues("lease_term") === "2 Years") {
                                                setValue("end_date", dayjs(e).add(2, "years").subtract(1, "day"));
                                            } else if (getValues("lease_term") === "3 Years") {
                                                setValue("end_date", dayjs(e).add(3, "years").subtract(1, "day"));
                                            } else {
                                                setValue("end_date", dayjs(e).add(1, "year").subtract(1, "day"));
                                            }


                                        }}
                                    />)}
                                />
                                {errors.start_date && (<p className={`${styles.ErrorM}`}>{errors.start_date.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="end_date"
                                    control={control}
                                    render={(field) => (<DatePicker
                                        {...field}
                                        label="Lease end date*"
                                        renderInput={(params) => (<TextField {...params} />)}
                                        onChange={(e) => {
                                            field.onChange(e);

                                            clearErrors();
                                            if (getValues("lease_term") === "6 Months") {
                                                setValue("start_date", dayjs(e).subtract(6, "months").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(6, "months").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(6, "months").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(6, "months").add(1, "day"));
                                            } else if (getValues("lease_term") === "9 Months") {
                                                setValue("start_date", dayjs(e).subtract(9, "months").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(9, "months").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(9, "months").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(9, "months").add(1, "day"));
                                            } else if (getValues("lease_term") === "1 Year") {
                                                setValue("start_date", dayjs(e).subtract(1, "year").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(1, "year").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(1, "year").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(1, "year").add(1, "day"));
                                            } else if (getValues("lease_term") === "2 Years") {
                                                setValue("start_date", dayjs(e).subtract(2, "years").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(2, "years").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(2, "years").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(2, "years").add(1, "day"));
                                            } else if (getValues("lease_term") === "3 Years") {
                                                setValue("start_date", dayjs(e).subtract(3, "years").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(3, "years").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(3, "years").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(3, "years").add(1, "day"));
                                            } else {
                                                setValue("start_date", dayjs(e).subtract(1, "year").add(1, "day"));
                                                setValue("move_in_date", dayjs(e).subtract(1, "year").add(1, "day"));

                                                setLeaseStartDate(dayjs(e).subtract(1, "year").add(1, "day"));
                                                setMoveInDate(dayjs(e).subtract(1, "year").add(1, "day"));
                                            }
                                        }}
                                    />)}
                                />
                                {errors.end_date && (<p className={`${styles.ErrorM}`}>{errors.end_date.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="move_in_date"
                                    control={control}
                                    render={(field) => (<DatePicker
                                        {...field}
                                        label="Move in date*"
                                        renderInput={(params) => (<TextField {...params} />)}
                                        onChange={(e) => {
                                            field.onChange(e);

                                            setMoveInDate(dayjs(e));
                                        }}
                                        minDate={dayjs(getValues("start_date"))}
                                    />)}
                                />
                                {errors.move_in_date && (<p className={`${styles.ErrorM}`}>{errors.move_in_date.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <Controller
                                    name="first_rent"
                                    control={control}
                                    render={(field) => (<MoneyField {...field} id="outlined-basic" variant="outlined" label="First Month Rent*" value={field.value ? field.value : ""} />)}
                                />
                                {errors.first_rent && (<p className={`${styles.ErrorM}`}>{errors.first_rent.message}</p>)}
                            </div>
                            <div className={`${styles.HalfSecHalf} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Do you want to upload an existing lease?*</InputLabel>
                                    <Controller
                                        name="is_existing"
                                        control={control}
                                        render={(field) => (<Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Do you want to upload an existing lease?*"
                                            onChange={(e) => {
                                                field.onChange(e);

                                                setSelectDocument([]);

                                                if (e?.target?.value === "Yes") {
                                                    setOpenUploadArea(true);
                                                    setOpenSelectArea(false);
                                                }
                                                if (e?.target?.value === "No") {
                                                    setOpenUploadArea(false);
                                                    setOpenSelectArea(true);
                                                }
                                            }}
                                        >
                                            <MenuItem value="Yes">Yes</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors.is_existing && (<p className={`${styles.ErrorM}`}>{errors.is_existing.message}</p>)}
                            </div>
                            {openSelectArea && <div className={`${styles.HalfSecFull} FormGroup`}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Select property lease documents*</InputLabel>
                                    <Controller
                                        name="docume_ids"
                                        control={control}
                                        render={(field) => (<Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectDocument}
                                            onChange={selectDocuments}
                                            onClick={(e) => {
                                                if ((typeof e.target?.parentElement?.classList?.contains("MenuListNew") !== "undefined" && e.target?.parentElement?.classList.contains("MenuListNew")) || (typeof e.target?.parentElement?.parentElement?.classList?.contains("MenuListNew") !== "undefined" && e.target?.parentElement?.parentElement?.classList.contains("MenuListNew"))) {
                                                    setDropdownOpen(true);
                                                } else if (e.target.localName === "span" && e.target.parentElement.classList.contains("DropListNew")) {
                                                    setDropdownOpen(false);
                                                } else if (e.target.localName === "div" && ((typeof e.target?.parentElement?.classList?.contains("DropListNew") !== "undefined" && e.target?.parentElement?.classList.contains("DropListNew")) || (typeof e.target?.parentElement?.parentElement?.classList?.contains("DropListNew") !== "undefined" && e.target?.parentElement?.parentElement?.classList.contains("DropListNew")))) {
                                                    setDropdownOpen(false);
                                                } else {
                                                    setDropdownOpen((prev) => !prev);
                                                }
                                            }}
                                            multiple
                                            input={<OutlinedInput label="Select property lease documents*" />}
                                            open={dropdownOpen}
                                            renderValue={(e) => (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} className={"DropListNew"}>
                                                    <ListManager
                                                        className={"DropListNew"}
                                                        items={sortedLeaseDocuments}
                                                        direction="horizontal"
                                                        maxItems={40}
                                                        render={(item) => (<ListElement item={item} />)}
                                                        onDragEnd={reorderList}
                                                    />
                                                </Box>
                                            )}
                                        >
                                            {LeaseDocumentOptions.map((item) => (
                                                <MenuItem key={item.id} value={item} className={"MenuListNew"}>
                                                    <Checkbox checked={selectDocumentIds.indexOf(item.id) > -1} />
                                                    <ListItemText primary={item.title} />
                                                </MenuItem>
                                            ))}
                                        </Select>)}
                                    />
                                </FormControl>
                                {errors.docume_ids && (<p className={`${styles.ErrorM}`}>{errors.docume_ids.message}</p>)}
                            </div>}
                            {openUploadArea && (<div className={`${styles.HalfSecFull}`}>
                                <div className={`${styles.FileUpDuBUDiv}`}>
                                    <label for="file-upload" className={`${styles.UploadLabel}`}>
                                        <span>
                                            <div className={`${styles.UpIcon}`}>
                                                <img src="/static/img/upload-floor.svg" alt="" />
                                            </div>
                                            <div>
                                                <p>Upload Existing Lease</p>
                                                <p className={`${styles.UploadText}`}>File size upto 10 MB <br /> PDF File only</p>
                                            </div>
                                        </span>
                                    </label>
                                    <input id="file-upload" type="file" onChange={fileHandler} accept=".pdf" />
                                    <input className="inputBtn" type="hidden" {...register("document_files")} />
                                </div>
                                {errors.document_files && (<p className={`${styles.ErrorM}`}>{errors.document_files.message}</p>)}
                                <div className={`${styles.UpIMGSecLease}`}>
                                    {uploadFiles?.map((item, index) => {
                                        return (<div className={`${styles.ImgFileLease}`} id={index}>
                                            <div className={`${styles.ImgFileUnderLease}`}>
                                                <img src="/static/img/pdf-file.png" alt="" />
                                                <div className={`${styles.ImgFileUnderConSecLease}`}>
                                                    <p className={`${styles.FileNameLease}`}>
                                                        <span>{item?.name}</span>
                                                    </p>
                                                    <p className={`${styles.FileSizeLease}`}>{dayjs().format("MM/DD/YYYY hh:mm A")}</p>
                                                </div>
                                                <div className={`${styles.FileListRightLease}`}>
                                                    <Button className={`${styles.FileListDeleteLease}`} onClick={removeFile.bind(this, index)}><Trash2 /></Button>
                                                </div>
                                            </div>
                                        </div>);
                                    })}
                                </div>
                            </div>)}
                            <div className={`${styles.ButtonArea}`}>
                                <button className={`${styles.ButtonVoiletLine}`} type="button" onClick={(e) => props.setAddLeaseModalOpen(false)}>Cancel</button>
                                <button className={`${styles.ButtonVoiletSolid}`} type="submit">Add</button>
                            </div>
                        </div>
                    </div>
                </LocalizationProvider>
            </form >
        </DialogContent>
    </>);
};

export default LeaseForm;